<!-- This contains NewOurProjects with bigger images -->
<template>
  <div class="relative bg-[#0f172a] overflow-x-hidden">
    <main>
      <section class="relative isolate py-24 sm:py-32">

        <!-- Text Section -->
        <div class="mx-auto max-w-4xl px-6 text-center text-white">
          <span class="text-xs tracking-[0.35em] font-semibold text-yellow-400">
            PROJECTS
          </span>

          <h2 class="mt-6 text-4xl sm:text-5xl font-extrabold">
            Our Projects
          </h2>

          <p class="mt-6 text-lg leading-8 text-slate-300">
            Oillead Integrated Services Ventures Limited (OLS) delivers onshore and offshore oil & gas projects across
            engineering, procurement, construction, installation, and commissioning.
          </p>

          <p class="mt-4 text-lg leading-8 text-slate-300">
            Our portfolio includes FPSO laser scanning, as-built engineering,
            3D model delivery, topside modifications, OEM support, and asset
            integrity solutions.
          </p>

          <div class="mt-10">
            <router-link
              to="/projects"
              class="inline-flex items-center gap-2 rounded-full
                   bg-yellow-400 px-8 py-3 text-sm font-semibold
                   text-black shadow-xl
                   hover:bg-yellow-400 hover:scale-105 transition-all"
            >
              View All Projects →
            </router-link>
          </div>
        </div>

        <!-- Images Section -->
        <div class="mt-16 mx-auto max-w-7xl px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-12">
          <!-- Project 1 -->
          <div class="text-center group">
            <img
              src="../assets/ourprojects1.png"
              alt="Gas Processing Plant"
              class="w-full h-[400px] sm:h-[450px] md:h-[500px]
                     rounded-2xl object-cover shadow-2xl ring-1 ring-white/10
                     hover:-translate-y-3 hover:scale-[1.03] transition-all duration-300"
            />
            <div class="mt-5">
              <p class="text-lg font-semibold tracking-wide text-white">
                Gas Processing Plant
              </p>
              <span class="mt-2 block h-px w-16 mx-auto bg-blue-400/40 group-hover:bg-yellow-400 transition"></span>
            </div>
          </div>

          <!-- Project 2 -->
          <div class="text-center group">
            <img
              src="../assets/ourprojects5.jpeg"
              alt="Equipment Installation"
              class="w-full h-[400px] sm:h-[450px] md:h-[500px]
                     rounded-2xl object-cover shadow-2xl ring-1 ring-white/10
                     hover:-translate-y-3 hover:scale-[1.03] transition-all duration-300"
            />
            <div class="mt-5">
              <p class="text-lg font-semibold tracking-wide text-white">
                Equipment Installation
              </p>
              <span class="mt-2 block h-px w-16 mx-auto bg-blue-400/40 group-hover:bg-yellow-400 transition"></span>
            </div>
          </div>

          <!-- Project 3 -->
          <div class="text-center group">
            <img
              src="../assets/ourprojects3.png"
              alt="Onshore Engineering Works"
              class="w-full h-[400px] sm:h-[450px] md:h-[500px]
                     rounded-2xl object-cover shadow-2xl ring-1 ring-white/10
                     hover:-translate-y-3 hover:scale-[1.03] transition-all duration-300"
            />
            <div class="mt-5">
              <p class="text-lg font-semibold tracking-wide text-white">
                Onshore Engineering Works
              </p>
              <span class="mt-2 block h-px w-16 mx-auto bg-blue-400/40 group-hover:bg-yellow-400 transition"></span>
            </div>
          </div>

          <!-- Project 4 -->
          <div class="text-center group">
            <img
              src="../assets/ourprojects6.jpeg"
              alt="Construction & Installation"
              class="w-full h-[400px] sm:h-[450px] md:h-[500px]
                     rounded-2xl object-cover shadow-2xl ring-1 ring-white/10
                     hover:-translate-y-3 hover:scale-[1.03] transition-all duration-300"
            />
            <div class="mt-5">
              <p class="text-lg font-semibold tracking-wide text-white">
                Construction & Installation
              </p>
              <span class="mt-2 block h-px w-16 mx-auto bg-blue-400/40 group-hover:bg-yellow-400 transition"></span>
            </div>
          </div>
        </div>

      </section>
    </main>
  </div>
</template>